/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FoodDrinkAlcoGlassWineIcon24Solid = forwardRef('FoodDrinkAlcoGlassWineIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 4.5A2.5 2.5 0 0 1 5.5 2h13A2.5 2.5 0 0 1 21 4.5v2.75c0 4.633-3.5 8.448-8 8.945V20h4.75a1 1 0 1 1 0 2H6.25a1 1 0 1 1 0-2H11v-3.805c-4.5-.497-8-4.312-8-8.945V4.5ZM5.5 4a.5.5 0 0 0-.5.5V7h14V4.5a.5.5 0 0 0-.5-.5h-13Z" })));
});
